import { apiInterceptor } from './ApiInterceptor';
import { URI } from '@/types/enum/api.enum';

export interface VehicleInfo {
  year: string;
  make: string;
  model: string;
  vin?: string;
  raw?: Record<string, unknown>;
}

export interface YMMSearchResult {
  suggestions: string[];
}

class VehicleService {
  public async getVehicleInfoByVIN(vin: string, signal?: AbortSignal): Promise<VehicleInfo> {
    try {
      const response = await apiInterceptor.get<VehicleInfo>(`${URI.BY_VIN}/${vin}`, undefined, signal);
      return response;
    } catch (error) {
      console.error('❌ VehicleService: VIN decode error:', error);
      throw error;
    }
  }

  public async getYMMSearch(searchString: string, signal?: AbortSignal): Promise<string[]> {
    try {
      const response = await apiInterceptor.get<string[]>(
        `${URI.SEARCH_YMM}/${encodeURIComponent(searchString)}`,
        undefined,
        signal
      );
      return response;
    } catch (error) {
      console.error('❌ VehicleService: YMM search error:', error);
      throw error;
    }
  }

  public async getYMMDecode(ymmString: string, signal?: AbortSignal): Promise<VehicleInfo> {
    try {
      const response = await apiInterceptor.get<VehicleInfo>(
        `${URI.BY_YMM}/${encodeURIComponent(ymmString)}`,
        undefined,
        signal
      );
      return response;
    } catch (error) {
      console.error('❌ VehicleService: YMM decode error:', error);
      throw error;
    }
  }
}

export const vehicleService = new VehicleService(); 